let isInteger = function (num) {
    if (isNaN(num)) {
        return false
    }
    else
        return true
}

export default isInteger;
